export const images21 = [
    {
        anchor: require("../images/2021/icicc-21-1.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-2.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-3.jpeg")
    },{
        anchor: require("../images/2021/icicc-21-4.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-5.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-6.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-7.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-8.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-9.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-10.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-11.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-12.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-13.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-14.jpeg")
    }, {
        anchor: require("../images/2021/icicc-21-15.jpeg")
    }, 
];

export const images20 = [
    {
        anchor: require("../images/2020/ic20-1.jpeg")
    },{
        anchor: require("../images/2020/ic20-2.jpeg")
    },{
        anchor: require("../images/2020/ic20-3.jpeg")
    },{
        anchor: require("../images/2020/ic20-4.jpeg")
    }, {
        anchor: require("../images/2020/ic20-5.jpeg")
    }, {
        anchor: require("../images/2020/ic20-6.jpeg")
    }, {
        anchor: require("../images/2020/ic20-7.jpeg")
    }, {
        anchor: require("../images/2020/ic20-8.jpeg")
    }, {
        anchor: require("../images/2020/ic20-9.jpeg")
    }, 
];

export const images19 = [
    {
        anchor: require("../images/2019/1.jpeg")
    },{
        anchor: require("../images/2019/2.jpeg")
    },{
        anchor: require("../images/2019/3.jpeg")
    },{
        anchor: require("../images/2019/4.jpeg")
    }, {
        anchor: require("../images/2019/5.jpeg")
    }, {
        anchor: require("../images/2019/6.jpeg")
    }, {
        anchor: require("../images/2019/7.jpeg")
    }, {
        anchor: require("../images/2019/8.jpeg")
    }, {
        anchor: require("../images/2019/9.jpeg")
    }, {
        anchor: require("../images/2019/10.jpeg")
    }, {
        anchor: require("../images/2019/11.jpeg")
    }, {
        anchor: require("../images/2019/12.jpeg")
    }, {
        anchor: require("../images/2019/13.jpeg")
    }, {
        anchor: require("../images/2019/14.jpeg")
    }, {
        anchor: require("../images/2019/15.jpeg")
    }, {
        anchor: require("../images/2019/16.jpeg")
    },  {
        anchor: require("../images/2019/17.jpeg")
    },  {
        anchor: require("../images/2019/18.jpeg")
    },  {
        anchor: require("../images/2019/19.jpeg")
    },  {
        anchor: require("../images/2019/20.jpeg")
    },  {
        anchor: require("../images/2019/21.jpeg")
    },   {
        anchor: require("../images/2019/22.jpeg")
    }, 
];

export const images18 = [
    {
        anchor: require("../images/2018/ic18-1.png")
    },{
        anchor: require("../images/2018/ic18-2.png")
    },{
        anchor: require("../images/2018/ic18-3.png")
    },{
        anchor: require("../images/2018/ic18-4.png")
    }, {
        anchor: require("../images/2018/ic18-5.png")
    },  
];